import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class RemoveContractFieldEnabled implements IFlagFeature {
  name = Features.RemoveContractFieldEnabled;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    // Implementa la lógica específica para determinar si la feature está habilitada
    return container[this.name].isEnabled();
  }
}
